export default "<div id=\"hc-negative-column\"></div>\n";